export default "__VITE_ASSET__2ef01daf__"